import styled from 'styled-components';

import H1 from '../../../global/typography/H1';

import { swatches } from '../../../../styles/theme';

const H2 = H1.withComponent('h2');

export default styled(H2)`
  color: ${swatches.white};
  line-height: 36px;
  margin: 0 0 24px 0;
`;
